import UmlCanvasToolbarButtons from './UmlCanvasToolbarButtons.jsx';
import { openOutputMsgDlg } from '../../../Widgets/OutputMsgWidget/UI/OutputMsgDlg/OutputMsgDlg.jsx';
import umlCanvasEngine from '../../Core/UmlCanvasEngine.js';
import umlViewportEngine from '../../Core/UmlViewportEngine.js';

/**
 * UmlCanvasToolbarButtonWidget — resolves derived values (zoom/snap/grid/hide-
 * interfaces) and binds handlers from the toolbar instance, then renders
 * UmlCanvasToolbarButtons. Keeps that prop list out of UmlCanvasToolbar.render().
 * @param {object} toolbar - the UmlCanvasToolbar class instance
 * @param {boolean} worldMapOpen
 * @param {Function} onToggleWorldMap
 * @param {boolean} hiddenItemsOpen
 * @param {Function} onToggleHiddenItems
 */
export default function UmlCanvasToolbarButtonWidget({ toolbar, worldMapOpen, onToggleWorldMap, hiddenItemsOpen, onToggleHiddenItems, isPackageSelected, onCopyPackage, pkgLibViewerOpen, onTogglePkgLibViewer }) {
    const zoomPercent = Math.round(umlViewportEngine.scale * 100);
    const snapToGrid = toolbar.context.settings['umlWorkspace.snapToGrid'];
    const gridSize = toolbar.context.settings['umlWorkspace.gridSize'];
    const hideInterfaces = umlCanvasEngine.viewConfig.hideInterfaces;

    return (
        <UmlCanvasToolbarButtons
            zoomPercent={zoomPercent}
            onAddPackage={toolbar.handleAddPackage}
            onAddClass={toolbar.handleAddClass}
            onAddRemarks={toolbar.handleAddRemarks}
            onAddIconShape={toolbar.handleAddIconShape}
            snapToGrid={snapToGrid}
            onToggleSnap={toolbar.handleToggleSnap}
            gridSize={gridSize}
            onGridSizeChange={toolbar.handleGridSizeChange}
            onOutputLog={openOutputMsgDlg}
            worldMapOpen={worldMapOpen}
            onToggleWorldMap={onToggleWorldMap}
            hiddenItemsOpen={hiddenItemsOpen}
            onToggleHiddenItems={onToggleHiddenItems}
            hideInterfaces={hideInterfaces}
            onToggleHideInterfaces={toolbar.handleToggleHideInterfaces}
            onFixLines={toolbar.handleFixLines}
            onAutoLayout={toolbar.handleAutoLayout}
            onUpdatePreview={toolbar.handleUpdatePreview}
            onExportImage={toolbar.handleOpenExportDlg}
            onCloseWorkspace={toolbar.handleCloseWorkspace}
            isPackageSelected={isPackageSelected}
            onCopyPackage={onCopyPackage}
            pkgLibViewerOpen={pkgLibViewerOpen}
            onTogglePkgLibViewer={onTogglePkgLibViewer}
        />
    );
}
